export default class TwilioConfigurationModel {
  public applications!: ConfigurationModel[];
  public workspaces!: ConfigurationModel[];

  constructor() {
    this.applications = [];
    this.workspaces = [];
  }
}

export class ConfigurationModel {
  public name!: string;
  public sid!: string;

  constructor() {
    this.name = "";
    this.sid = "";
  }
}
